import { InjectionToken } from '@angular/core';
import { ISafeAny } from './mock.type';

export const MOCK_CONFIG = new InjectionToken<ISafeAny>('mock.config');

